<template>
  <div style="background: #FAF9F5;">
    <!-- Start blog-posts Area -->
    <section class="blog-posts-area section-padding">
      <div class="container" style="background: #fff">
        <div class="row">
          <div class="col-lg-12 post-list blog-post-list">
            <div class="single-post">

<!--              <ul class="tags">-->
<!--                <li><a href="#">Art</a></li>-->
<!--                <li><a href="#">Technology</a></li>-->
<!--                <li><a href="#">Fashion</a></li>-->
<!--              </ul>-->

                <h2 class="blog-detail-tit">
                  {{ currentBlog.title }}
                </h2>


              <div class="blog-detail-img">
                <img class="img-fluid wow slideInLeft" :src="currentBlog.img" alt="">
              </div>

              <div class="blog-detail-content content-wrap  wow slideInRight">
                <p v-html="currentBlog.content">
                </p>



<!--                <blockquote class="generic-blockquote">-->
<!--                  In conclusion, as we celebrate our school’s anniversary, let us remember the legacy we carry forward and the promise of tomorrow. Let us cherish the memories we have created and the friendships we have forged. May this day be a testament to the enduring spirit of our school community and the values we hold dear. Happy anniversary to our school, and here’s to many more years of learning, growing, and succeeding together. Thank you.-->
<!--                </blockquote>-->

<!--              x-->



              </div>


              <!-- Start nav Area -->
<!--              <section class="nav-area py-5">-->
<!--                <div class="container">-->
<!--                  <div class="row justify-content-between">-->
<!--                    <div class="col-sm-6 nav-left justify-content-start d-flex">-->
<!--                      <div class="thumb" style="width: 120px;">-->
<!--                        <img style="width: 100%;" src="static/assets/images/news2.jpg" alt="">-->
<!--                      </div>-->
<!--                      <div class="post-details">-->
<!--                        <p>Prev Post</p>-->
<!--                        <h4 class="text-uppercase"><a href="#">A Discount Toner</a></h4>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                    <div class="col-sm-6 nav-right justify-content-end d-flex">-->
<!--                      <div class="post-details">-->
<!--                        <p>Prev Post</p>-->
<!--                        <h4 class="text-uppercase"><a href="#">A Discount Toner</a></h4>-->
<!--                      </div>-->
<!--                      <div class="thumb" style="width: 120px;">-->
<!--                        <img style="width: 100%;" src="static/assets/images/news3.jpg" alt="">-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </section>-->
              <!-- End nav Area -->

            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End blog-posts Area -->
  </div>
</template>

<script>
  export default {
    data () {
      return {
        currentBlog: {},
        blogList: [
          {
            id: '1',
            title: 'Suzhou Campus holds the inaugural Suzhou Forum on Humanistic Economics and the unveiling ceremony of the Suzhou Research Center for Humanistic Economics of Renmin University. ',
            img: 'http://en.sc.ruc.edu.cn/static/images/home/news.png',
            date: 'January 14, 2018',
            author: 'Mark wiens',
            content: 'The inaugural Suzhou Forum on Humanistic Economics and the unveiling ceremony of the Suzhou Research Center for Humanistic Economics of Renmin University of China was held at the Suzhou campus on December 24, 2023.<br/>' +
              'With the theme of "The Humanistic Economics of the Suzhou Miracle," the forum saw academic dialogues and exchanges among over 40 experts from various fields nationwide. Attendees included Zhang Donggang, Chair of the University Council, Lin Shangli, President of RUC, Liu Xiaotao, Standing Committee of the Jiangsu Provincial Party Committee and Secretary of the Suzhou Municipal Party Committee, Qu Futian, Deputy Director of the Standing Committee of the Jiangsu Provincial People\'s Congress and Chairman of the Jiangsu Provincial Federation of Social Sciences, and Wu Qingwen, Mayor of Suzhou, as well as Hong Yinxing, former Secretary of the Party Committee of Nanjing University and economist. The Suzhou Research Center for Humanistic Economy of Renmin University of China will contribute wisdom to the modernization and development of Suzhou by conducting research projects on "Humanistic Economics in Suzhou," and exploring the humanistic economics theories and experiences. '
          }, {
            id: '2',
            title: 'Suzhou Campus holds the Tenth Policy Forum in Asia',
            img: 'http://en.sc.ruc.edu.cn/static/images/home/news1.png',
            date: 'January 14, 2018',
            author: 'Mark wiens',
            content: 'The Tenth Policy Forum in Asia was held at Suzhou Campus, with the theme: challenges and governance in the digital age. Zhang Donggang, Chair of the University Council, Zheng Xinye, Vice President, as well as Satoshi Nakano, President and Dun Yamada, Vice President of Ichibashi University, attended the forum. Scholars from the two universities gave keynote speeches from different perspectives on opportunities and challenges brought by digital transformation, conducting discussions on new trends of scientific research and technological innovation in the digital age, changes in folk beliefs, local intangible cultural heritage customs related to water, international governance of e-commerce, the American Industrial Chain Alliance, characteristics of artificial intelligence and trust between human and machine.'
          }
        ]
      }
    },
    created () {
      const id = this.$route.query.id
      this.currentBlog = this.getId(id)
      console.log(id, this.currentBlog)
    },
    methods: {
      getId (id) {
        return this.blogList.find(item => item.id === id)
      }
    }
  }
</script>

<style scoped lang="scss">
.blog-detail-tit{
  font-weight: bold;
  font-size: 20px;
  color: #333333;
  line-height: 38px;
  width: 90%;
  margin: 0 auto;
  text-align: center;
  padding: 60px 0px 20px 0px;
}
.blog-detail-img{
  width: 70%;
  margin:  0 auto;
}
.blog-detail-content{
  width: 90%;
  margin: 40px auto 10px auto;
    p{
      font-weight: 400;
      font-size: 15px;
      line-height: 1.6;
      color: #666666;
    }
}
</style>



// WEBPACK FOOTER //
// BlogDetails.vue?b36654fa